
<div [ngClass]="{'admin-contents-area-small': commonService.menuSmall$ | async, 'h100': commonService.classNameH100$ | async}">
  <router-outlet></router-outlet>
</div>